import { useContext } from 'react';

import { type MenuContextProps, MenuContext } from '../contexts/MenuContext.js';

/** @internal */
export const useMenuContext = (): MenuContextProps => {
  return useContext(MenuContext);
};
